import * as React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";

type PageLayoutProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  // кнопки справа от заголовка
  actions?: React.ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl";
  children: React.ReactNode;
};

// Общая обёртка страниц кабинета: отступ под фиксированную шапку (Toolbar),
// под свёрнутое боковое меню (65px на sm+) и под нижнюю навигацию на телефоне (Footer, < 800px).
export default function PageLayout({ title, subtitle, actions, maxWidth = "lg", children }: PageLayoutProps) {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        pt: { xs: "72px", sm: "88px" },
        pl: { xs: 0, sm: "65px" },
        pb: { xs: "96px", md: "96px" },
      }}
    >
      <Container maxWidth={maxWidth}>
        {(title || actions) && (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            gap={2}
            sx={{ mb: 3 }}
          >
            <Box>
              {title && (
                <Typography variant="h4" component="h1">
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
            {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
          </Stack>
        )}
        {children}
      </Container>
    </Box>
  );
}
